import { useSyncExternalStore } from "react";

export type NavigationMode = "topbar" | "sidebar";

const key = "vigepra_navigation_mode";
const changeEvent = "vigepra:navigation-mode";
let memoryMode: NavigationMode = "topbar";

const read = (): NavigationMode => {
    try {
        return localStorage.getItem(key) === "sidebar" ? "sidebar" : "topbar";
    } catch {
        return memoryMode;
    }
};

const subscribe = (notify: () => void): (() => void) => {
    const storage = (event: StorageEvent): void => {
        if (event.key === key || event.key === null) {
            notify();
        }
    };
    window.addEventListener(changeEvent, notify);
    window.addEventListener("storage", storage);
    return () => {
        window.removeEventListener(changeEvent, notify);
        window.removeEventListener("storage", storage);
    };
};

const setMode = (mode: NavigationMode): void => {
    memoryMode = mode;
    try {
        localStorage.setItem(key, mode);
    } catch {
        /* Keep the preference available when storage is blocked. */
    }
    window.dispatchEvent(new Event(changeEvent));
};

export const useNavigationMode = (): [
    NavigationMode,
    (mode: NavigationMode) => void,
] => [useSyncExternalStore(subscribe, read, () => "topbar"), setMode];
